const e = {
  code: "en",
  facebook: "en_US",
  label: "English",
  loadingText: "Loading...",
  translations: {
    ar: "Arabic",
    de: "German",
    en: "English",
    es: "Spanish",
    fr: "French",
    he: "Hebrew",
    hi: "Hindi",
    id: "Indonesian",
    it: "Italian",
    ja: "Japanese",
    km: "Khmer",
    ko: "Korean",
    lo: "Lao",
    ms: "Malay",
    nl: "Dutch",
    pt: "Portuguese",
    ru: "Russian",
    th: "Thai",
    tl: "Filipino",
    tr: "Turkish",
    vi: "Vietnamese",
    "zh-CN": "Chinese (Simp.)",
    "zh-TW": "Chinese (Trad.)"
  }
};
export {
  e as english
};
